module.exports = __webpack_public_path__ + "img/logo-google.f674458f.png";